"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kendo_react_common_1 = require("@progress/kendo-react-common");
/**
 * @hidden
 */
var navigate = function (focusedIndex, keyCode, altKey, total) {
    if (altKey) {
        return focusedIndex;
    }
    switch (keyCode) {
        case kendo_react_common_1.Keys.enter:
        case kendo_react_common_1.Keys.space:
        case kendo_react_common_1.Keys.esc:
            return -1;
        case kendo_react_common_1.Keys.up:
        case kendo_react_common_1.Keys.left:
            return Math.max(0, focusedIndex - 1);
        case kendo_react_common_1.Keys.down:
        case kendo_react_common_1.Keys.right:
            return Math.min(total - 1, focusedIndex + 1);
        default:
            return focusedIndex;
    }
};
exports.default = navigate;
//# sourceMappingURL=navigation.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-buttons@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-buttons/dist/npm/ListButton/utils/navigation.js
// module id = 287
// module chunks = 0